import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";

import { supabase } from "@/integrations/supabase/client";
import { SiteLayout } from "@/components/site/SiteLayout";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Acesso ao painel | Chavel Chaveiro Betim" },
      { name: "description", content: "Área restrita da equipe Chavel Chaveiro em Betim." },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Acesso ao painel | Chavel Chaveiro Betim" },
      { property: "og:description", content: "Área restrita da equipe Chavel Chaveiro." },
    ],
  }),
  component: AuthPage,
});

function AuthPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState<"login" | "signup">("login");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    const action =
      mode === "login"
        ? supabase.auth.signInWithPassword({ email, password })
        : supabase.auth.signUp({ email, password, options: { emailRedirectTo: window.location.origin + "/admin" } });
    const { error } = await action;
    setLoading(false);
    if (error) {
      toast.error(error.message);
      return;
    }
    toast.success(mode === "login" ? "Bem-vindo!" : "Conta criada. Verifique seu e-mail se necessário.");
    void navigate({ to: "/admin" });
  }

  return (
    <SiteLayout>
      <div className="container-page flex justify-center py-16">
        <form onSubmit={handleSubmit} className="w-full max-w-md rounded-xl border border-border bg-card p-7">
          <h1 className="font-display text-2xl">Painel Chavel</h1>
          <p className="mt-1 text-sm text-muted-foreground">Acesso restrito à equipe.</p>

          <label className="mt-6 block text-sm font-medium" htmlFor="email">E-mail</label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          />

          <label className="mt-4 block text-sm font-medium" htmlFor="password">Senha</label>
          <input
            id="password"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          />

          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground disabled:opacity-60"
          >
            {loading ? "Aguarde…" : mode === "login" ? "Entrar" : "Criar conta"}
          </button>

          <button
            type="button"
            onClick={() => setMode(mode === "login" ? "signup" : "login")}
            className="mt-3 w-full text-sm text-muted-foreground underline"
          >
            {mode === "login" ? "Criar uma conta" : "Já tenho conta"}
          </button>
        </form>
      </div>
    </SiteLayout>
  );
}
